import styled from 'styled-components';

const StyledCommentHeader = styled.div`
	display: flex;
	gap: var(--spacing-large);
	align-items: end;
	& > span {
		flex-grow: 1;
	}
	.motif-button.motif-button .motif-icon {
		--size: var(--px-20);
	}
`;

export default StyledCommentHeader;
